import {useEffect, useState} from "react";
import axios from "axios";
import {partnerOfferings} from "./utils";
import {
  googleClientId,
  googleScript,
  baseUrl,
  gatewayUrl,
} from "@maya/helper/ui-shared";
import {loadExternalScript} from "@maya/helper/utilities";
import {tokenUtility} from "@maya/helper/data-access";

const SignInSesction = ({
  queryParams,
  redirectParam,
  from,
}: {
  queryParams?: string;
  redirectParam?: string;
  from?: Location;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const query = new URLSearchParams(queryParams);
  const utm_source = query.has("utm_source") ? query.get("utm_source") : "";

  const signInRedirect = async (
    credential: string,
    utmParam?: string | null,
  ) => {
    setIsLoading(true);
    try {
      const res = await axios({
        method: "POST",
        url: `${gatewayUrl}/hagrid/signin/google`,
        data: {
          ...(utmParam ? {utmParams: {source: utmParam}} : {}),
        },
        headers: {
          Authorization: `Bearer ${credential}`,
        },
      });
      const {dsToken} = res.data;
      tokenUtility().storeToken(dsToken);
    } finally {
      setIsLoading(false);
    }

    if (redirectParam) {
      window.location.href = `${baseUrl}/${redirectParam}/#/${
        query.toString() ? `?${query.toString()}` : ""
      }`;
    } else if (from?.pathname) {
      window.location.href = `${baseUrl}/#${from.pathname}`;
    } else {
      window.location.href = `${baseUrl}/loans/#/`;
    }
  };

  useEffect(() => {
    loadExternalScript(googleScript, () => {
      (window as any).google.accounts.id.initialize({
        client_id: googleClientId,
        cancel_on_tap_outside: false,
        auto_select: true,
        itp_support: true,
        callback: async (cred: {credential: string; select_by: string}) => {
          signInRedirect(cred.credential, utm_source);
        },
      });
      (window as any).google.accounts.id.renderButton(
        document.getElementById("google-button"),
        {size: "large", theme: "filled_blue", width: 330},
      );
    });
  }, []);

  return (
    <div className="w-full mx-auto max-w-100 bg-white text-black p-8 rounded-xs shadow">
      {utm_source ? (
        <div className="mb-8">
          <h1 className="mb-4">In association with</h1>
          {utm_source && utm_source in partnerOfferings && (
            <img
              src={
                partnerOfferings[utm_source as keyof typeof partnerOfferings]
                  .logo
              }
              alt="partner"
              className="h-[125px] w-full"
            />
          )}
        </div>
      ) : (
        <>
          <h2 className="text-xl font-bold mb-6">
            Sign-in to access our Products
          </h2>
          <ul className="list-disc pl-5 space-y-2 font-bold text-base marker:text-orange-500 marker:text-3xl">
            <li>Unsecured Business Loans</li>
            <li>Insurance</li>
            <li>Mutual Funds</li>
            <li>And More!</li>
          </ul>
        </>
      )}

      <button
        id="google-button"
        className="my-3 flex justify-center w-full pt-3 relative"
      >
        {isLoading && (
          <progress className="progress w-[90%] h-0.5 progress-primary absolute top-full"></progress>
        )}
      </button>

      <button className="w-full text-orange-600 text-sm font-medium py-3 border border-orange-200 rounded-lg hover:bg-orange-50">
        Click here to change your Email Id
      </button>

      <p className="mt-6 text-xs text-center text-gray-600">
        By clicking Sign In, you accept our{" "}
        <a href="#" className="text-blue-500 underline">
          Terms & Conditions
        </a>{" "}
        and{" "}
        <a href="#" className="text-blue-500 underline">
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
};

export default SignInSesction;
